module.exports = __webpack_public_path__ + "media/images/WFC_Award_Black-496302aaf9596609f323e355647ad4f2.png";